/* ef-docs.js - the documentation centre's filter, search and sort.
 *
 * Every row is rendered server-side and filtered by toggling `hidden`. That is
 * deliberate and it is the whole SEO argument for the page: these rows are
 * internal links to 21 manual pages, and a list built by JavaScript from a
 * JSON blob is a list Google may or may not choose to render. The DOM already
 * carries the answer; this file only hides parts of it.
 *
 * The product rail and the sidebar checkboxes drive the SAME state, because
 * they filter the same thing. Two controls with two states for one filter is
 * how a page ends up showing a selected chip and an unticked box for the same
 * product; clicking a rail card ticks its box and vice versa.
 *
 * State also lives in the URL (?product=&topic=&q=&sort=), so a filtered view
 * is a link someone can send - the same fix the compare page needed. Written
 * with replaceState, never pushState: filtering is not navigation, and a back
 * button that walks through nine keystrokes is a broken back button.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-doc-list]');
  if (!root) return;

  var rows     = Array.prototype.slice.call(root.children);
  var railBtns = Array.prototype.slice.call(document.querySelectorAll('[data-doc-rail]'));
  var prodBox  = Array.prototype.slice.call(document.querySelectorAll('[data-doc-product]'));
  var topicBox = Array.prototype.slice.call(document.querySelectorAll('[data-doc-topic]'));
  var langBox  = Array.prototype.slice.call(document.querySelectorAll('[data-doc-lang]'));
  var qEl      = document.querySelector('[data-doc-q]');
  var sortEl   = document.querySelector('[data-doc-sort]');
  var headEl   = document.querySelector('[data-doc-heading]');
  var emptyEl  = document.querySelector('[data-doc-empty]');
  var clearEl  = document.querySelector('[data-doc-clear]');
  var activeEl = document.querySelector('[data-doc-activefilters]');
  var track    = document.querySelector('[data-doc-rail-track]');
  var prevEl   = document.querySelector('[data-doc-rail-prev]');
  var nextEl   = document.querySelector('[data-doc-rail-next]');
  var panel    = document.querySelector('.ef-docs__filterdisclosure');

  var state = { products: [], topics: [], langs: [], q: '', sort: 'product' };

  /* Sort keys are read once, not inside the comparator: getAttribute would
   * run O(n log n) times per repaint over 68 rows. */
  rows.forEach(function (r) {
    r._p = r.getAttribute('data-product') || '';
    r._t = r.getAttribute('data-topic') || '';
    r._l = r.getAttribute('data-lang') || '';
    r._n = r.getAttribute('data-name') || '';
    r._u = r.getAttribute('data-updated') || '';
    r._k = r.getAttribute('data-sortkey') || r._n;
  });

  function readUrl() {
    var q = new URLSearchParams(location.search);
    state.products = (q.get('product') || '').split(',').filter(Boolean);
    state.topics   = (q.get('topic') || '').split(',').filter(Boolean);
    state.langs    = (q.get('lang') || '').split(',').filter(Boolean);
    state.q        = (q.get('q') || '').toLowerCase();
    state.sort     = q.get('sort') === 'updated' ? 'updated' : 'product';
    if (qEl) qEl.value = q.get('q') || '';
    prodBox.forEach(function (b) { b.checked = state.products.indexOf(b.value) > -1; });
    topicBox.forEach(function (b) { b.checked = state.topics.indexOf(b.value) > -1; });
    langBox.forEach(function (b) { b.checked = state.langs.indexOf(b.value) > -1; });
  }

  function writeUrl() {
    var q = new URLSearchParams();
    if (state.products.length) q.set('product', state.products.join(','));
    if (state.topics.length) q.set('topic', state.topics.join(','));
    if (state.langs.length) q.set('lang', state.langs.join(','));
    if (state.q) q.set('q', state.q);
    if (state.sort === 'updated') q.set('sort', 'updated');
    var s = q.toString();
    history.replaceState(null, '', s ? location.pathname + '?' + s : location.pathname);
  }

  function matches(r) {
    if (state.products.length && state.products.indexOf(r._p) === -1) return false;
    if (state.topics.length && state.topics.indexOf(r._t) === -1) return false;
    if (state.langs.length && state.langs.indexOf(r._l) === -1) return false;
    if (state.q && r._n.indexOf(state.q) === -1) return false;
    return true;
  }

  function order(a, b) {
    if (state.sort === 'updated') {
      /* Undated rows sort last, not first. Eleven models have no published
       * PDF date, and letting an empty string win a string comparison would
       * float them above a real 2026 date - a lie told by a sort. */
      if (a._u !== b._u) {
        if (!a._u) return 1;
        if (!b._u) return -1;
        return a._u < b._u ? 1 : -1;              /* newest first */
      }
      return a._k < b._k ? -1 : 1;
    }
    return a._k < b._k ? -1 : (a._k > b._k ? 1 : 0);
  }

  /* Their heading restates the topic filter: "All Topics" until one is
   * picked, then the topic's own name. It is the only label that says what
   * the list below is, so it tracks the filter rather than the result count -
   * the count lives beside "Filter". */
  function heading() {
    if (state.topics.length === 1) return state.topics[0];
    if (state.topics.length > 1) return state.topics.length + ' Topics';
    return 'All Topics';
  }

  function paint() {
    var shown = 0;
    rows.forEach(function (r) {
      var ok = matches(r);
      r.hidden = !ok;
      if (ok) shown++;
    });

    /* Reorder in one fragment. Appending 68 live nodes individually forces a
     * reflow per node; the fragment costs one. */
    var frag = document.createDocumentFragment();
    rows.slice().sort(order).forEach(function (r) { frag.appendChild(r); });
    root.appendChild(frag);

    railBtns.forEach(function (btn) {
      var on = state.products.indexOf(btn.getAttribute('data-doc-rail')) > -1;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    if (headEl) headEl.textContent = heading();
    if (activeEl) {
      var n = shown === 1 ? '1 document' : shown + ' documents';
      activeEl.textContent = n;
    }
    if (emptyEl) emptyEl.hidden = shown !== 0;
    if (clearEl) {
      clearEl.hidden = !(state.products.length || state.topics.length
                        || state.langs.length || state.q);
    }
    if (sortEl) {
      sortEl.textContent = state.sort === 'updated'
        ? 'Sort by Product' : 'Sort by Update Time';
      sortEl.setAttribute('aria-label', state.sort === 'updated'
        ? 'Sorted by update time. Switch to sorting by product.'
        : 'Sorted by product. Switch to sorting by update time.');
    }
    railNav();
    writeUrl();
  }

  function toggle(list, value) {
    var i = list.indexOf(value);
    if (i > -1) list.splice(i, 1); else list.push(value);
  }

  /* Tick a product in the sidebar and its rail card is very often scrolled
   * out of the strip - 21 cards, six visible - so the rail silently shows
   * nothing selected while the list below is filtered. Bring it into view. */
  function revealRail(pid) {
    if (!track) return;
    var btn = railBtns.filter(function (b) {
      return b.getAttribute('data-doc-rail') === pid;
    })[0];
    if (!btn) return;
    var t = track.getBoundingClientRect(), r = btn.getBoundingClientRect();
    if (r.left >= t.left - 1 && r.right <= t.right + 1) return;
    track.scrollLeft += r.left - t.left - (t.width - r.width) / 2;
  }

  prodBox.forEach(function (b) {
    b.addEventListener('change', function () {
      toggle(state.products, b.value);
      paint();
      if (b.checked) revealRail(b.value);
    });
  });
  topicBox.forEach(function (b) {
    b.addEventListener('change', function () {
      toggle(state.topics, b.value);
      paint();
    });
  });
  langBox.forEach(function (b) {
    b.addEventListener('change', function () {
      toggle(state.langs, b.value);
      paint();
    });
  });

  railBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pid = btn.getAttribute('data-doc-rail');
      toggle(state.products, pid);
      /* Keep the checkbox in step - one state, two affordances. */
      prodBox.forEach(function (b) {
        if (b.value === pid) b.checked = state.products.indexOf(pid) > -1;
      });
      paint();
    });
  });

  if (qEl) {
    qEl.addEventListener('input', function () {
      state.q = qEl.value.trim().toLowerCase();
      paint();
    });
    /* Swallow Enter. There is nowhere to submit to and the list is already
     * live, but a form wrapper added later would otherwise reload the page. */
    qEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
    });
  }

  if (sortEl) {
    sortEl.addEventListener('click', function () {
      state.sort = state.sort === 'updated' ? 'product' : 'updated';
      paint();
    });
  }

  if (clearEl) {
    clearEl.addEventListener('click', function () {
      state.products = [];
      state.topics = [];
      state.langs = [];
      state.q = '';
      if (qEl) qEl.value = '';
      prodBox.concat(topicBox, langBox).forEach(function (b) { b.checked = false; });
      paint();
    });
  }

  /* ---- rail scrolling ---- */
  function railNav() {
    if (!track || !prevEl || !nextEl) return;
    var max = track.scrollWidth - track.clientWidth;
    prevEl.disabled = track.scrollLeft <= 1;
    nextEl.disabled = track.scrollLeft >= max - 1;
  }
  if (track) {
    var step = function (dir) {
      /* Scroll by whole cards, not a fixed pixel count: a card is 116px at
       * every breakpoint here, but reading it off the DOM survives a change
       * to the CSS. */
      var card = track.querySelector('.ef-docs__railitem');
      var w = card ? card.getBoundingClientRect().width + 8 : 124;
      track.scrollLeft += dir * w * 3;
    };
    if (prevEl) prevEl.addEventListener('click', function () { step(-1); });
    if (nextEl) nextEl.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', railNav, { passive: true });
    window.addEventListener('resize', railNav);
  }

  /* The filter panel ships as <details open> so that with JavaScript off it
   * is readable on every width - CSS makes its summary inert above 900px, so
   * a panel that shipped closed could never be opened there.
   *
   * With JavaScript on, a phone gets it collapsed: eight filter rows plus 21
   * product rows between the search field and the first document is most of
   * a screen of controls before any content. Widening past 900px opens it
   * again, so someone who collapsed it on a phone and then rotated or resized
   * is not left with a panel they can no longer reach. */
  if (panel) {
    var syncPanel = function () {
      panel.open = window.innerWidth >= 900;
    };
    syncPanel();
    window.addEventListener('resize', syncPanel);
  }

  readUrl();
  paint();
  /* A shared ?product= link lands with the rail unscrolled for the same
   * reason. This runs twice on purpose: on the next frame, which is right in
   * the common case, and again on load. At first paint the product
   * photographs have no intrinsic size yet, so the strip can still measure as
   * unscrollable and the assignment clamps to 0 - measured, and it is why the
   * rail sometimes revealed the selection and sometimes did not. */
  if (state.products.length) {
    var revealFirst = function () { revealRail(state.products[0]); };
    requestAnimationFrame(revealFirst);
    /* At first paint the strip can still measure as unscrollable, so the
     * assignment above clamps to 0 - measured, and it is why the rail
     * sometimes revealed the selection and sometimes did not. Watching the
     * track fires the moment it has its real width. `load` also works but
     * waits on 21 product photographs, which put the correction seconds
     * later and made the rail jump under the reader. */
    if (window.ResizeObserver && track) {
      var ro = new ResizeObserver(function () {
        if (track.scrollWidth > track.clientWidth) {
          revealFirst();
          ro.disconnect();
        }
      });
      ro.observe(track);
    } else {
      window.addEventListener('load', revealFirst);
    }
  }
})();


/* ---------------------------------------------------------------------------
 * The manual reader's Contents rail.
 *
 * Separate IIFE because this file serves two pages: the hub, whose block above
 * returns early when [data-doc-list] is absent, and the 21 manual pages, which
 * have a Contents rail and no list. One asset, two guards.
 *
 * IntersectionObserver rather than a scroll handler: the browser computes the
 * intersections off the main thread, so this costs nothing on a 4,000-word
 * page, and a scroll handler would have to measure every heading on every
 * frame.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  var links = Array.prototype.slice.call(document.querySelectorAll('[data-man-toc]'));
  if (!links.length) return;

  var byId = {};
  var targets = [];
  links.forEach(function (a) {
    var id = a.getAttribute('data-man-toc');
    var el = document.getElementById(id);
    if (!el) return;                       /* a Contents entry with no section */
    byId[id] = a;
    targets.push(el);
  });
  if (!targets.length) return;

  var current = null;
  function mark(id) {
    if (id === current) return;
    current = id;
    links.forEach(function (a) {
      a.classList.toggle('is-on', a.getAttribute('data-man-toc') === id);
    });
  }

  /* THE SELECTION RULE, which is the whole thing.
   *
   * The first attempt asked an IntersectionObserver for a band across the
   * upper viewport and marked the first section intersecting it. That lagged
   * by one entry everywhere: a section shorter than the band never fills it,
   * and between two sections nothing intersects at all, so the rail kept
   * whatever was last lit.
   *
   * "The last heading you have scrolled past" has neither failure. It is
   * defined at every scroll position, including the top of the page and the
   * bottom of the document, and it is what a reader means by "where am I".
   */
  /* The line is a FIXED offset, not a fraction of the viewport. A quarter of
   * the way down is 250px on a laptop, and the short sections here - warranty
   * is 166px, service 128px - means three of them clear a 250px line at once
   * and the marker runs two ahead of the reader. Just under the sticky header
   * is the position that means "the top of what you are looking at".
   */
  var LINE = 96;

  function spy() {
    /* At the bottom of the document the last sections can never reach the
     * line - there is no scroll left - so without this the rail sticks
     * several entries short and the final heading is unreachable. */
    if (window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 2) {
      mark(targets[targets.length - 1].id);
      return;
    }
    var found = targets[0].id;
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].getBoundingClientRect().top <= LINE) found = targets[i].id;
      else break;                  /* sections are in document order */
    }
    mark(found);
  }

  /* rAF-throttled, and the frame is released in the callback rather than by a
   * timer. A latch that is raised on scroll and only lowered by a callback
   * that might not run is how the film scrub died once; here the lowering is
   * unconditional. */
  var queued = false;
  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; spy(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  links.forEach(function (a) {
    /* Mark instantly on click. The scroll handler confirms it a frame later,
     * but waiting for a smooth scroll to arrive reads as a dead control. */
    a.addEventListener('click', function () {
      mark(a.getAttribute('data-man-toc'));
    });
  });

  /* Same treatment as the hub's filter panel: ships open for the no-script
   * case, collapsed on a phone so the manual starts higher, and re-opened on
   * the way back up past 900px where the summary is inert. */
  var toc = document.querySelector('.ef-man__tocwrap');
  if (toc) {
    var syncToc = function () { toc.open = window.innerWidth >= 900; };
    syncToc();
    window.addEventListener('resize', syncToc);
    /* Jumping to a section should put the list away on a phone, or the
     * reader lands behind the thing they just tapped through. */
    links.forEach(function (a) {
      a.addEventListener('click', function () {
        if (window.innerWidth < 900) toc.open = false;
      });
    });
  }

  spy();
})();
